import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

interface IDistributorUser {
  username: string;
  email: string;
  password?: string;
  distributorUserType: string;
  status?: string;
}
export default function useUpdateDistributorUser() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  async function execute(distributorUserId: string, data: IDistributorUser) {
    try {
      setLoading(true);
      const response = await api.put(
        `v1/backoffice/distributor-users/${distributorUserId}`,
        {
          username: data.username,
          email: data.email,
          password: data.password,
          distributorUserType: data.distributorUserType,
          status: data.status,
        },
      );

      if (response.status === 200) {
        history.goBack();
        toast.success(
          ToastMessages.distributorUser.success.updateDistributorUser,
        );
      }
    } catch (error) {
      return toast.error(ToastMessages.distributorUser.error.updateUser);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
